import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const HIGHLIGHT = "starter";

export default function Pricing() {
  const [packs, setPacks] = useState([]);
  const [busy, setBusy] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/packs").then(({ data }) => setPacks(data));
  }, []);

  const buy = async (pack) => {
    setBusy(pack.id);
    try {
      const { data } = await api.post("/checkout/session", {
        pack_id: pack.id,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not start checkout");
      setBusy(null);
    }
  };

  return (
    <div className="px-6 pt-6 pb-8" data-testid="pricing-page">
      <div className="mm-card mb-4">
        <div className="mm-label mb-2">Get more scans</div>
        <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">
          Pick a scan pack that fits you
        </h1>
        <p className="text-sm text-slate-600 mt-2">
          Pay once, use your scans anytime. No subscription unless you want one.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {packs.map((pack) => {
          const highlight = pack.id === HIGHLIGHT;
          return (
            <div
              key={pack.id}
              className={`rounded-3xl border ${highlight ? "border-2 border-blue-700 bg-blue-50" : "border-slate-200 bg-white"} p-5`}
              data-testid={`pack-${pack.id}`}
            >
              {highlight && (
                <div className="mm-label text-blue-700 mb-2">Recommended</div>
              )}
              <div className="flex items-baseline justify-between mb-1">
                <div className="font-extrabold text-lg text-slate-900">{pack.name}</div>
                <div className="font-mono font-extrabold text-2xl text-slate-900">
                  ${pack.price.toFixed(2)}
                </div>
              </div>
              <ul className="mt-3 space-y-2 text-sm text-slate-700">
                <li className="flex items-center gap-2">
                  <Check className="text-blue-700" size={14} strokeWidth={3} />
                  <span className="font-mono font-bold">{pack.scans}</span>
                  <span>item {pack.scans === 1 ? "scan" : "scans"}</span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="text-blue-700" size={14} strokeWidth={3} />
                  Scans do not expire
                </li>
                {pack.id === "pro" && (
                  <li className="flex items-center gap-2">
                    <Check className="text-blue-700" size={14} strokeWidth={3} />
                    Saved item history + unlimited generated listings
                  </li>
                )}
              </ul>
              <button
                className={`mt-4 ${highlight ? "mm-btn-primary" : "mm-btn-secondary"} !h-12 !text-sm`}
                onClick={() => buy(pack)}
                disabled={busy === pack.id}
                data-testid={`buy-${pack.id}-btn`}
              >
                {busy === pack.id ? (
                  <>
                    <Loader2 className="animate-spin" size={16} /> Redirecting…
                  </>
                ) : (
                  <>Buy {pack.name}</>
                )}
              </button>
            </div>
          );
        })}
      </div>

      <button
        className="mm-btn-secondary mt-6"
        onClick={() => navigate(-1)}
        data-testid="pricing-back-btn"
      >
        Back
      </button>
    </div>
  );
}
